import React, { useEffect } from 'react'

function useGetQuestionsFromChildren(props) {
  const questions = {
    byId: {},
    allIds: [],
  }

  useEffect(() => {
    React.Children.forEach(props.children, (childQuestion, childQuestionIdx) => {
      if (childQuestion.type.displayName === 'QuizQuestion') {
        const { children, ...rest } = childQuestion.props

        const question = {
          ...rest,
          id: `question-${childQuestionIdx + 1}`,
          prefix: childQuestionIdx + 1,
          form: null,
          message: null,
        }

        React.Children.forEach(childQuestion.props.children, subchildQuestion => {
          if (subchildQuestion.type.displayName === 'QuizQuestionForm') {
            question.form = subchildQuestion.props.children
          }

          if (subchildQuestion.type.displayName === 'QuizQuestionFeedback') {
            question.message = subchildQuestion.props.children
          }
        })

        questions.byId[question.id] = question
        questions.allIds.push(question.id)
      }
    })
  }, [])

  return questions
}

export default useGetQuestionsFromChildren